import React, { Component } from 'react'
import images from '../../config/images'
import Camera from 'material-ui/svg-icons/image/camera-alt'
import Upload from 'material-ui/svg-icons/file/file-upload'

import { getImageURI } from '../../lib'

class ProfilePic extends Component {
  render() {
    const imageURI = getImageURI(this.props.userid, images.avatar)
    return (
      <div
        style={{height: this.props.height}}
        className='flex justify-center w-100'>
        <div
          className='br-100 panel-box'>
          <img
            style={{borderRadius: '100%', border: (this.props.userid) ? '1px solid #d9d9d9' : ''}}
            className='h-100 w-100 front box-style'
            src={imageURI} alt='avatar'/>
          <div
            style={{backgroundColor: '#6B7C93'}}
            className='flex flex-column h-100 w-100 br-100 pointer back'>
            <div
              className='h-100 w-100'>
              <div
                onTouchTap={() => this.props.takePicture(true)}
                style={{borderBottom: '1px solid #FFFFFF'}}
                className='h-50 flex justify-center items-center'>
                <Camera style={{fill: '#FFFFFF'}}/>
              </div>
              <div
                onTouchTap={() => this.props.uploadPicture(true)}
                className='h-50 flex justify-center items-center'>
                <Upload
                  style={{fill: '#FFFFFF'}}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default ProfilePic



// WEBPACK FOOTER //
// src/components/ProfilePic/ProfilePic.js